export enum WizardSubstepConditions {
  BASIC = "basic",
  COMPLETED = "completed",
  COMPLETE = "completed",
  ACTIVE = "active"
}
